/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ProductSummary {
  activeFeedbackId?: number;
  brandEquity?: number;
  brandId?: number;
  brandName?: string;
  category?: string;
  categoryExternalId?: number;
  categoryExternalIdString?: string;
  categoryId?: number;
  categoryLevel?: number;
  categoryName?: string;
  dateCreated?: Date;
  dateUpdated?: Date;
  externalId?: string;
  internalEAN?: string;
  internalEANGrouped?: string;
  productId?: number;
  productName?: string;
  productSummary?: string;
  productVariantId?: number;
  ratingAverage?: number;
  reviewCount?: number;
  stock?: number;
  variantCount?: number;
}
